module.exports = __webpack_public_path__ + "img/careerroad.3cafd432.avif";